import HDGULogo from '@/assets/branding/hdgu/hdgu.svg';

const colors = {
  // Brand colors
  brand_primary: '#F58220',
  brand_primary_hover: '#CF6913', // -10 L, -8 S
  brand_primary_highlight: '#FEC18C', // +23 L, +7 S
  brand_primary_mid: '#F99845', // +8 L,  +2 S
  brand_primary_dark: '#8D4509', // -25 L, -3 S
  brand_secondary: '#B36816', // hue +4 deg, -15 L, -13 S
  brand_accent_start: '#FA9338',
  brand_accent_end: '#F2BD36',
  brand_accent_light_start: '#FFF4EB',
  brand_accent_light_end: '#FFF3D6',
  brand_complementary_accent: 'rgb(52,180,244)',
  brand_auth_gradient_mid: '#B36816',
  brand_auth_gradient_end: '#8D4509',
  brand_auth_warp_mid: '#F99845',
};

export default {
  name: 'HDGU',
  isSAML: true,
  allowPersonalCourses: false,
  logo: HDGULogo,
  colors,
};
